import { ICON } from '../../config/icons';

import './DataCard.scss';

interface DataCardSmallProps {
  icon?: keyof typeof ICON; // icons
  label: string;
  customLabel?: string;
}

export const DataCardSmall = ({ icon, label, customLabel }: DataCardSmallProps) => {
  return (
    <div className="data-card small">
      {icon && (
        <div className="icon">
          <img src={icon} alt={label} />
        </div>
      )}
      <div className="content">
        <div className="label">{customLabel || label}</div>
      </div>
    </div>
  );
};
